$(document).ready(function () {


    $(document).on("click", "#CurrencySelectFromBar", function (e) {

        var hs = window.location.hash;
        hs = hs.replace("=", "[_]");
        hs = hs.replace("&", "[and]");
        var currencyID = $("#CurrencyChange option:selected").attr("data-id");
        var langCode = $("#LangChange option:selected").attr("data-langcode");
        var CountryCode = $("#CountryCode option:selected").val();


        if ((currencyID != null && currencyID != "" && currencyID != undefined && (typeof currencyID !== 'undefined')) &&
            (CountryCode != null && CountryCode != "" && CountryCode != undefined && (typeof CountryCode !== 'undefined'))) {

            $.ajax({
                type: 'get',
                url: '/Home/ChangeCurrency',
                // data: 'Url=' + $("#Url").val() + "&currencyID=" + $('input[name=currencyID]:checked').val() + "&hash=" + window.location.hash + "&countryCode=" +$("#CountryCode").val(),
                data: "&currencyID=" + currencyID + "&countryCode=" + CountryCode,
                success: function (dt) {

                    //change page lang

                    var url = "/";
                    var Catalogs = $("#PgCatalogs").val().split("/");
                    var ctlgs = "";

                    for (var i = 0; i < Catalogs.length; i++) {
                        if (Catalogs[i].length > 0) {
                            ctlgs += "&Cats=" + Catalogs[i];
                        }
                    }

                    var PID = $("#PID").val();
                    var PgType = $("#PgType").val();
                    var AName = $("#AName").val();
                    var CName = $("#CName").val();
                    var LangID = $("#LangChange option:selected").attr("data-id");
                    var LangCode = $("#LangChange option:selected").attr("data-langcode");

                    var hashValue = $("#hash").val();
                    hashValue = hashValue.split("=").join("_");
                    hashValue = hashValue.split(",").join("$");
                    hashValue = hashValue.split("#").join("sorsware-");

                    $.ajax({

                        type: 'get',

                        url: '/Home/ChangePageLang',

                        data: 'PID=' + PID + "&hash=" + hashValue + "&PgType=" + PgType + "&AName=" + AName + "&CName=" + CName + "&langID=" + LangID + ctlgs + "&langCode=" + LangCode,

                        success: function (data) {
                            //alert("GELEN DATA : " + data);

                            window.parent.location.href = data;
                        },

                        error: function (err) {
                            alert("Talebiniz yerine getirilirken bir hata oluştu.");
                        }

                    });

                }
            });
        }
    });

    // YENİ LANGUAGE SWITCH - DROPDOWNLIST
    $(".LangCon #LangChange").change(function () {
        var langID = $("#LangChange option:selected").attr("data-id");
        var langCode = $("#LangChange option:selected").attr("data-langcode");
        dilDegistir(langID, langCode);

        //  return false;
        //  e.preventDefault();
        //  window.parent.location.href = "/" + langCode;
    });

    $(document).on("click", "#langSwitch2", function () {
        $("#langSwitch").trigger("click");
    });

    // LAYOUT SWİTCH
    $(document).on("click", "#langSwitch", function () {

        var LangID = $("#LangID").val();
        var SmallLangCode = $("#SmallLangCode").val();
        var checkUlke, checkDil, checkPara = false;

        if ($("#CountryCode option").length < 1 || $("#LangList option").length < 1 || $("#CurrencyList option").length < 1) {

            // ÜLKE LİSTESİ ÇAĞIRMA
            $.ajax({
                type: 'get',
                url: '/LangSwitch/GetCountryListFromLangCode',
                data: 'langCode=' + LangID,
                cache: false,
                success: function (dt) {
                    $.each(dt, function (k, v) {

                        if (v.Selected == true) {
                            $("#CountryCode").append('<option value="' + v.Value + '" selected>' + v.Text + '</option>');
                        }
                        else {
                            $("#CountryCode").append('<option value="' + v.Value + '">' + v.Text + '</option>');
                        }
                    });
                    checkUlke = true;
                }
            });

            // DİL LİSTESİ ÇAĞIRMA
            $.ajax({
                type: 'get',
                url: '/LangSwitch/GetLangList',
                cache: false,
                success: function (dt) {

                    $.each(dt, function (k, v) {
                        if (SmallLangCode == v.LangCode) {
                            $("#LangList").append('<option value="' + v.LangCode + '" data-id="' + v.ID + '" selected>' + v.Name + '</option>');
                        }
                        else {
                            $("#LangList").append('<option value="' + v.LangCode + '" data-id="' + v.ID + '" >' + v.Name + '</option>');
                        }
                    });
                    checkDil = true;
                }
            });

            // PARA BİRİMİ LİSTESİ ÇAĞIRMA
            $.ajax({
                type: 'get',
                url: '/LangSwitch/GetCurrencyList',
                cache: false,
                success: function (dt) {
                    var activeCurrency = $.cookie("CurrencyCode");
                    $.each(dt, function (k, v) {
                        if (activeCurrency == v.CurrencyCode) {
                            $("#CurrencyList").append('<option value="' + v.ID + '" selected>' + v.CurrencySymbol + '</option>');
                        }
                        else {
                            $("#CurrencyList").append('<option value="' + v.ID + '">' + v.CurrencySymbol + '</option>');
                        }
                    });
                    checkPara = true;
                }
            });

        }

        $("#langSwitchModal").modal({
            keyboard: false,
            handleUpdate: false,
            backdrop: 'static'
        });

    });

    $(document).on("change", "#LangList", function () {
        var langID = $("#LangList option:selected").attr("data-id");
        var langCode = $("#LangList option:selected").val();

        $.ajax({
            type: 'get',
            url: '/LangSwitch/GetCountryListFromLangCode',
            cache: false,
            data: 'langCode=' + langID,
            success: function (dt) {

                var seciliUlke = $("#CountryCode option:selected").val();
                $("#CountryCode").find("option").remove();
                $.each(dt, function (k, v) {
                    if (seciliUlke == v.Value) {
                        $("#CountryCode").append('<option value="' + v.Value + '" selected>' + v.Text + '</option>');
                    }
                    else {
                        $("#CountryCode").append('<option value="' + v.Value + '">' + v.Text + '</option>');
                    }
                });

                if (langCode == "en") {
                    $("#ChangeLanguageButton").html("Select and Continue");
                    $("#CancelLangButton").html("Cancel");
                    $("#langSwitchModalLabel").html("REGION AND LANGUAGE SELECTION");

                    // $("#langSwitchModal .ulkeLabel").html("Country");
                    // $("#langSwitchModal .dilLabel").html("Language");
                    // $("#langSwitchModal .paraLabel").html("Currency Unit");
                }
                else if (langCode == "fr") {
                    $("#ChangeLanguageButton").html("Sélectionnez et Continuez");
                    $("#CancelLangButton").html("Annuler");
                    $("#langSwitchModalLabel").html("SÉLECTION DE LA RÉGION ET DE LA LANGUE");

                    // $("#langSwitchModal .ulkeLabel").html("Pays");
                    // $("#langSwitchModal .dilLabel").html("language");
                    // $("#langSwitchModal .paraLabel").html("Unité Monétaire");
                }
                else {
                    $("#ChangeLanguageButton").html("Seç ve Devam Et");
                    $("#CancelLangButton").html("İptal");
                    $("#langSwitchModalLabel").html("DİL VE BÖLGE SEÇİMİ");

                    // $("#langSwitchModal .ulkeLabel").html("Ülke");
                    // $("#langSwitchModal .dilLabel").html("Dil");
                    // $("#langSwitchModal .paraLabel").html("Para Birimi");
                }

            }
        });

    });

    $(document).on("click", "#ChangeLanguageButton", function () {

        var CurrencyID = $("#CurrencyList option:selected").val();
        var LangCode = $("#LangList option:selected").val();
        var CountryCode = $("#CountryCode option:selected").val();

        $("#langSwitchModal #ChangeLanguageButton").attr("disabled", "disabled");
        //$("#langSwitchModal #ModalClose").attr("disabled", "disabled");
        $("#langSwitchModal #ModalClose").html("");
        $("#CountryCode").attr("disabled", "disabled");
        $("#LangList").attr("disabled", "disabled");
        $("#CurrencyList").attr("disabled", "disabled");

        var waitString = "";
        if (LangCode == "tr") {
            waitString = "Lütfen Bekleyiniz";
        }
        else if (LangCode == "en") {
            waitString = "Please Wait";
        }
        else {
            waitString = "S'il Vous Plaît, Attendez";
        }
        $("#langSwitchModal #ChangeLanguageButton").html("<img src='/Images/ajax-loader.gif' /> <span style='padding-left:10px;'>" + waitString + "</span>");

        $.ajax({
            type: 'get',
            url: '/Home/ChangeCurrency',
            data: "&currencyID=" + CurrencyID + "&countryCode=" + CountryCode,
            success: function (dt) {

                var url = "/";
                var Catalogs = $("#PgCatalogs").val().split("/");
                var ctlgs = "";

                for (var i = 0; i < Catalogs.length; i++) {
                    if (Catalogs[i].length > 0) {
                        ctlgs += "&Cats=" + Catalogs[i];
                    }
                }

                var PID = $("#PID").val();
                var PgType = $("#PgType").val();
                var AName = $("#AName").val();
                var CName = $("#CName").val();
                var LangID = $("#LangList option:selected").attr("data-id");
                var LangCode = $("#LangList option:selected").val();

                $.ajax({
                    type: 'get',
                    url: '/Home/ChangePageLang',
                    data: 'PID=' + PID + /*"&hash=" + hashValue +*/ "&PgType=" + PgType + "&AName=" + AName + "&CName=" + CName + "&langID=" + LangID + ctlgs + "&langCode=" + LangCode,
                    success: function (data) {
                        // alert("GELEN DATA : " + data);
                        window.parent.location.href = data;
                    },

                    error: function (err) {
                        alert("Talebiniz yerine getirilirken bir hata oluştu.");
                    }

                });

            },
            error: function () {
                $("#langSwitchModal #ChangeLanguageButton").attr("enabled", "enabled");
                $("#langSwitchModal #ModalClose").html("&times;");
                alert("Bir hata oluştu. Lütfen tekrar deneyiniz.");
            }
        });

    });

    $(document).on("change", "#CountryCode", function () {
        var CountryCode = $("#CountryCode option:selected").val();

        $.ajax({
            type: 'GET',
            url: '/LangSwitch/GetCurrencyList',
            cache: false,
            data: "countryCode=" + CountryCode,
            success: function (data) {

                var selectedCurrency = $("#CurrencyList option:selected").val();

                $("#CurrencyList").find("option").remove();

                $.each(data, function (k, v) {
                    if (selectedCurrency == v.ID) {
                        $("#CurrencyList").append('<option value="' + v.ID + '" selected>' + v.CurrencySymbol + '</option>');
                    }
                    else {
                        $("#CurrencyList").append('<option value="' + v.ID + '">' + v.CurrencySymbol + '</option>');
                    }
                });
            }
        });
    });

});

function dilDegistir(LangID, langCode) {
    var url = "/";
    var Catalogs = $("#PgCatalogs").val().split("/");
    var ctlgs = "";
    var hashValue = $("#hash").val();

    for (var i = 0; i < Catalogs.length; i++) {
        if (Catalogs[i].length > 0) {
            ctlgs += "&Cats=" + Catalogs[i];
        }
    }

    hashValue = hashValue.split("=").join("_");
    hashValue = hashValue.split(",").join("$");
    hashValue = hashValue.split("#").join("sorsware-");

    var param = "PgType=" + $("#PgType").val() + "&hash=" + hashValue + "&AName=" + $("#AName").val() + "&CName=" + $("#CName").val() + ctlgs + "&langID=" + LangID + "&langCode=" + langCode + "&PID='" + $("#PID").val();
    console.log(param);

    $.ajax({
        type: 'get',
        url: '/Home/ChangePageLang',
        data: param,
        success: function (data) {
            var seciliUlke = $("#CountryCode option:selected").val();
            $("#CountryCode").find("option").remove();

            $.ajax({
                type: 'get',
                url: '/LangSwitch/GetCountryListFromLangCode',
                cache: false,
                data: 'langCode=' + LangID,
                success: function (dt) {

                    $.each(dt, function (k, v) {
                        if (seciliUlke == v.Value) {
                            $("#CountryCode").append('<option value="' + v.Value + '" selected>' + v.Text + '</option>');
                        }
                        else {
                            $("#CountryCode").append('<option value="' + v.Value + '">' + v.Text + '</option>');
                        }
                    });

                    if (LangID == "2") {
                        $(".ChooseBtn").html("Select and Continue <i class='glyphicon glyphicon-arrow-right'></i>");
                    }
                    else if (LangID == "3") {
                        $(".ChooseBtn").html("Sélectionnez et Continuez <i class='glyphicon glyphicon-arrow-right'></i>");
                    }
                    else {
                        $(".ChooseBtn").html("Seç ve Devam Et <i class='glyphicon glyphicon-arrow-right'></i>");
                    }

                }
            });

        },
        error: function (err) {
            alert("Talebiniz yerine getirilirken bir hata oluştu.");
        }
    });
}